import { InputAdornment, TextField } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"

export const SearchWidget = ({ search, setSearch, placeholder = "Search communities, events, topics…" }) => {
    return (
        <TextField
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={placeholder}
            variant="outlined"
            size="small"
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={{ color: "#732982" }} />
                    </InputAdornment>
                ),
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                    borderRadius: 50,
                    background: '#fff',
                    boxShadow: '0 2px 8px rgba(99,100,255,0.08)',
                    '& fieldset': { borderColor: 'rgba(115,41,130,0.25)' },
                    '&:hover fieldset': { borderColor: '#732982' },
                    '&.Mui-focused fieldset': { borderColor: '#732982' },
                },
            }}
        />
    )
}
